export default __webpack_public_path__ + "static/media/karada-arrange-brand-story-top-01.49300cb2.jpg";